export const ROUTES = {
  HOME: "/",
  WILD_CARD: "*",
  DASHBOARD: "/dashboard",
  COMPONENTS_TEST: "/components",
  APIS: "/apis",
  APIS_ALL: "/apis/all",
  ONBOARD: "/onboard/:productId",
} as const;

export const PUBLIC_ROUTES = {
  MARKETPLACE: "/marketplace",
  MARKETPLACE_APIS: "/marketplace/apis",
  MARKETPLACE_APIS_DETAIL: "/marketplace/detail",

} as const;

export const API_ENDPOINTS_ROUTES = {
  // WALLETS_GET_TRANSACTIONS: "/admin/getWalletHistory",
  WALLETS_GET_TRANSACTIONS: "/admin/getWalletReport",
  REPORTS_GET_REPORTS: "/admin/getCallsReport",
  REPORTS_GET_REPORTS_SEARCH: "/admin/getCallsReport",
  DOWNLOAD_TRANSACTIONS: "/admin/walletHistoryDownload",
  DOWNLOAD_REPORTS: "/admin/callsHistoryDownload",
} as const;

export const UI_AUTHENTICATED_ROUTES = {
  DASHBOARD: "/dashboard",
  WALLET_TRANSACTIONS: "/dashboard/transactions",
  TRANSACTIONS: "/dashboard/transactions",
  REPORTS: "/dashboard/reports",
} as const;
